module.exports = __webpack_public_path__ + "img/logo-parciais.2923991a.png";